var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.options),function(item,idx){return (item.selected)?_c('span',{key:'rb-'+idx,staticClass:"item",class:{'selected': item.value === _vm.value},on:{"click":function($event){return _vm.clickItem(item)}}},[_vm._v(_vm._s(item.label))]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }